class PaginateNextPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      
      const finalUrl = this.dataset.url + `&section_id=${this.dataset.sectionId}` + (window.location.search ? window.location.search.replace('?', '&') : '');
      console.log(finalUrl);
      const parentSection = this.closest('.shopify-section');

      fetch(finalUrl)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          
          const productsList = html.querySelector('#product-grid');

          parentSection.querySelector('#product-grid').insertAdjacentHTML('beforeend', productsList.innerHTML);

          if (html.querySelector('paginate-next-page')) {
            const nextPagePagination = html.querySelector('paginate-next-page');
            this.after(nextPagePagination);
          }

          this.remove();
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('paginate-next-page', PaginateNextPage);